module.exports = {
        automation_ops :"automation_ops",
        sap_ops :"sap_ops",
        oem_ops:"oem_ops",
        salesforce_ops:"salesforce_ops",
        custom_ops: "custom_ops"
  };